import Radio from '../Radio/Radio'
import classes from './LabeledRadio.module.scss'

export interface Props{
  isChecked?: boolean
  isDisabled?: boolean
  label: string
  onChange: (value: any) => void
  value?: string
}

const LabeledRadio = ({
  label,
  isChecked = false,
  isDisabled = false,
  onChange,
  value
}: Props) => {
  // eslint-disable-next-line complexity
  const getClasses = () => {
    const baseClass = classes.LabeledRadio

    const isCheckedClass = isChecked
      ? classes.isChecked
      : ''

    const isDisabledClass = isDisabled
      ? classes.Disabled
      : ''

    const isCheckedIsDisabled = isChecked && isDisabled
      ? classes.isCheckedAndIsDisabled
      : ''

    const isUnCheckedAndIsDisabled = !isChecked && isDisabled
      ? classes.isUnCheckedAndIsDisabled
      : ''

    const finalClasses = [
      baseClass,
      isCheckedClass,
      isDisabledClass,
      isCheckedIsDisabled,
      isUnCheckedAndIsDisabled
    ].filter(classname => classname)

    return finalClasses.join(' ')
  }

  return (
    <label className={getClasses()}>
      <Radio
        isChecked={isChecked}
        isDisabled={isDisabled}
        onChange={onChange}
        value={value}
      />
      {label}
    </label>
  )
}

export default LabeledRadio
